import { DomainRule } from '../../types';
import { OnClickConfig } from 'sections/onsite-campaigns/types/onClick';
import { TriggerType } from 'sections/onsite-campaigns/types';

export interface OnClickSelectorRequiredRuleDto {
  selectedTriggers: TriggerType[];
  onClick: OnClickConfig;
}

export const OnClickSelectorRequiredRuleKey = 'onClickSelectorRequired';

export const OnClickSelectorRequiredRule = (dto: OnClickSelectorRequiredRuleDto): DomainRule => {
  if (dto?.selectedTriggers?.includes(TriggerType.OnClick) && !dto.onClick?.selector) {
    return {
      result: 'fail',
      ruleKey: OnClickSelectorRequiredRuleKey,
    };
  }

  return {
    result: 'pass',
    ruleKey: undefined,
  };
};
